module.exports = __webpack_public_path__ + "static/media/DSS-2x.7fe8efc0.jpeg";